<template>
  <MoleculesConsumerModal v-model="hasModalOpenRef">
    <slot />
  </MoleculesConsumerModal>
</template>

<script setup lang="ts">
const hasModalOpenRef = ref(false)
const toggleModal = (): void => {
  hasModalOpenRef.value = !hasModalOpenRef.value
}
defineExpose({
  toggleModal,
})
</script>
